const typeStatusString = () => {
  let data = {};
  data[statusPayment.PENDING] = "در حال انتظار";
  data[statusPayment.PAID] = "پرداخت شده";
  data[statusPayment.FAILED] = "ناموفق";

  return data;
};

const statusPayment = {
  PENDING: 0,
  PAID: 1,
  FAILED: 2,
};

export default {
  typeStatusString,
  statusPayment,
};
